import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Student } from "../../components/Education/Students/types/student";

interface StudentState {
  studentList: Student[];
  selectedStudent: Student | null;
}

const initialState: StudentState = {
  studentList: [],
  selectedStudent: null
};

const studentSlice = createSlice({
  name: "students",
  initialState,
  reducers: {
    setStudentList: (state, action: PayloadAction<Student[]>) => {
      state.studentList = action.payload;
    },
    setSelectedStudent: (state, action: PayloadAction<Student | null>) => {
      state.selectedStudent = action.payload;
    },
    addStudent: (state, action: PayloadAction<Student>) => {
      state.studentList = [action.payload, ...state.studentList];
    },
    updateStudentInList: (state, action: PayloadAction<Student>) => {
      state.studentList = state.studentList.map((student) =>
        student.id === action.payload.id ? action.payload : student
      );
      if (state.selectedStudent?.id === action.payload.id) {
        state.selectedStudent = action.payload;
      }
    }
  }
});

export const {
  setStudentList,
  setSelectedStudent,
  addStudent,
  updateStudentInList
} = studentSlice.actions;

export default studentSlice.reducer;
